import React, { useState, useEffect, useCallback } from 'react';
import './KeyboardTester.css';

const WINDOWS_LAYOUT = [
  [
    { label: 'Esc', code: 'Escape', w: 1 }, { spacer: true, w: 0.5 },
    { label: 'F1', code: 'F1' }, { label: 'F2', code: 'F2' }, { label: 'F3', code: 'F3' }, { label: 'F4', code: 'F4' },
    { spacer: true, w: 0.4 },
    { label: 'F5', code: 'F5' }, { label: 'F6', code: 'F6' }, { label: 'F7', code: 'F7' }, { label: 'F8', code: 'F8' },
    { spacer: true, w: 0.4 },
    { label: 'F9', code: 'F9' }, { label: 'F10', code: 'F10' }, { label: 'F11', code: 'F11' }, { label: 'F12', code: 'F12' },
    { spacer: true, w: 0.4 },
    { label: 'PrtSc', code: 'PrintScreen' }, { label: 'ScrLk', code: 'ScrollLock' }, { label: 'Pause', code: 'Pause' },
  ],
  [
    { label: '`', code: 'Backquote' }, { label: '1', code: 'Digit1' }, { label: '2', code: 'Digit2' },
    { label: '3', code: 'Digit3' }, { label: '4', code: 'Digit4' }, { label: '5', code: 'Digit5' },
    { label: '6', code: 'Digit6' }, { label: '7', code: 'Digit7' }, { label: '8', code: 'Digit8' },
    { label: '9', code: 'Digit9' }, { label: '0', code: 'Digit0' }, { label: '-', code: 'Minus' },
    { label: '=', code: 'Equal' }, { label: 'Backspace', code: 'Backspace', w: 2 },
    { spacer: true, w: 0.4 },
    { label: 'Ins', code: 'Insert' }, { label: 'Home', code: 'Home' }, { label: 'PgUp', code: 'PageUp' },
    { spacer: true, w: 0.4 },
    { label: 'NmLk', code: 'NumLock' }, { label: '/', code: 'NumpadDivide' }, { label: '*', code: 'NumpadMultiply' }, { label: '-', code: 'NumpadSubtract' },
  ],
  [
    { label: 'Tab', code: 'Tab', w: 1.5 },
    { label: 'Q', code: 'KeyQ' }, { label: 'W', code: 'KeyW' }, { label: 'E', code: 'KeyE' },
    { label: 'R', code: 'KeyR' }, { label: 'T', code: 'KeyT' }, { label: 'Y', code: 'KeyY' },
    { label: 'U', code: 'KeyU' }, { label: 'I', code: 'KeyI' }, { label: 'O', code: 'KeyO' },
    { label: 'P', code: 'KeyP' }, { label: '[', code: 'BracketLeft' }, { label: ']', code: 'BracketRight' },
    { label: '\\', code: 'Backslash', w: 1.5 },
    { spacer: true, w: 0.4 },
    { label: 'Del', code: 'Delete' }, { label: 'End', code: 'End' }, { label: 'PgDn', code: 'PageDown' },
    { spacer: true, w: 0.4 },
    { label: '7', code: 'Numpad7' }, { label: '8', code: 'Numpad8' }, { label: '9', code: 'Numpad9' }, { label: '+', code: 'NumpadAdd', h: 2 },
  ],
  [
    { label: 'Caps', code: 'CapsLock', w: 1.8 },
    { label: 'A', code: 'KeyA' }, { label: 'S', code: 'KeyS' }, { label: 'D', code: 'KeyD' },
    { label: 'F', code: 'KeyF' }, { label: 'G', code: 'KeyG' }, { label: 'H', code: 'KeyH' },
    { label: 'J', code: 'KeyJ' }, { label: 'K', code: 'KeyK' }, { label: 'L', code: 'KeyL' },
    { label: ';', code: 'Semicolon' }, { label: "'", code: 'Quote' },
    { label: 'Enter', code: 'Enter', w: 2.2 },
    { spacer: true, w: 3.8 },
    { label: '4', code: 'Numpad4' }, { label: '5', code: 'Numpad5' }, { label: '6', code: 'Numpad6' },
  ],
  [
    { label: 'Shift', code: 'ShiftLeft', w: 2.3 },
    { label: 'Z', code: 'KeyZ' }, { label: 'X', code: 'KeyX' }, { label: 'C', code: 'KeyC' },
    { label: 'V', code: 'KeyV' }, { label: 'B', code: 'KeyB' }, { label: 'N', code: 'KeyN' },
    { label: 'M', code: 'KeyM' }, { label: ',', code: 'Comma' }, { label: '.', code: 'Period' },
    { label: '/', code: 'Slash' }, { label: 'Shift', code: 'ShiftRight', w: 2.7 },
    { spacer: true, w: 0.4 },
    { label: '↑', code: 'ArrowUp' },
    { spacer: true, w: 0.4 },
    { label: '1', code: 'Numpad1' }, { label: '2', code: 'Numpad2' }, { label: '3', code: 'Numpad3' }, { label: 'En', code: 'NumpadEnter', h: 2 },
  ],
  [
    { label: 'Ctrl', code: 'ControlLeft', w: 1.4 }, { label: '⊞', code: 'MetaLeft' },
    { label: 'Alt', code: 'AltLeft', w: 1.3 }, { label: 'Space', code: 'Space', w: 5.5 },
    { label: 'Alt', code: 'AltRight', w: 1.3 }, { label: '☰', code: 'ContextMenu' },
    { label: 'Ctrl', code: 'ControlRight', w: 1.4 },
    { spacer: true, w: 0.4 },
    { label: '←', code: 'ArrowLeft' }, { label: '↓', code: 'ArrowDown' }, { label: '→', code: 'ArrowRight' },
    { spacer: true, w: 0.4 },
    { label: '0', code: 'Numpad0', w: 2 }, { label: '.', code: 'NumpadDecimal' },
  ],
];

const MAC_LAYOUT = [
  [
    { label: 'Esc', code: 'Escape', w: 1 }, { spacer: true, w: 0.5 },
    { label: 'F1', code: 'F1' }, { label: 'F2', code: 'F2' }, { label: 'F3', code: 'F3' }, { label: 'F4', code: 'F4' },
    { spacer: true, w: 0.4 },
    { label: 'F5', code: 'F5' }, { label: 'F6', code: 'F6' }, { label: 'F7', code: 'F7' }, { label: 'F8', code: 'F8' },
    { spacer: true, w: 0.4 },
    { label: 'F9', code: 'F9' }, { label: 'F10', code: 'F10' }, { label: 'F11', code: 'F11' }, { label: 'F12', code: 'F12' },
    { spacer: true, w: 0.4 },
    { label: 'Pwr', code: 'Power' },
  ],
  [
    { label: '`', code: 'Backquote' }, { label: '1', code: 'Digit1' }, { label: '2', code: 'Digit2' },
    { label: '3', code: 'Digit3' }, { label: '4', code: 'Digit4' }, { label: '5', code: 'Digit5' },
    { label: '6', code: 'Digit6' }, { label: '7', code: 'Digit7' }, { label: '8', code: 'Digit8' },
    { label: '9', code: 'Digit9' }, { label: '0', code: 'Digit0' }, { label: '-', code: 'Minus' },
    { label: '=', code: 'Equal' }, { label: '⌫ Del', code: 'Backspace', w: 2 },
  ],
  [
    { label: 'Tab', code: 'Tab', w: 1.5 },
    { label: 'Q', code: 'KeyQ' }, { label: 'W', code: 'KeyW' }, { label: 'E', code: 'KeyE' },
    { label: 'R', code: 'KeyR' }, { label: 'T', code: 'KeyT' }, { label: 'Y', code: 'KeyY' },
    { label: 'U', code: 'KeyU' }, { label: 'I', code: 'KeyI' }, { label: 'O', code: 'KeyO' },
    { label: 'P', code: 'KeyP' }, { label: '[', code: 'BracketLeft' }, { label: ']', code: 'BracketRight' },
    { label: '\\', code: 'Backslash', w: 1.5 },
  ],
  [
    { label: 'Caps', code: 'CapsLock', w: 1.8 },
    { label: 'A', code: 'KeyA' }, { label: 'S', code: 'KeyS' }, { label: 'D', code: 'KeyD' },
    { label: 'F', code: 'KeyF' }, { label: 'G', code: 'KeyG' }, { label: 'H', code: 'KeyH' },
    { label: 'J', code: 'KeyJ' }, { label: 'K', code: 'KeyK' }, { label: 'L', code: 'KeyL' },
    { label: ';', code: 'Semicolon' }, { label: "'", code: 'Quote' },
    { label: 'Return', code: 'Enter', w: 2.2 },
  ],
  [
    { label: '⇧ Shift', code: 'ShiftLeft', w: 2.3 },
    { label: 'Z', code: 'KeyZ' }, { label: 'X', code: 'KeyX' }, { label: 'C', code: 'KeyC' },
    { label: 'V', code: 'KeyV' }, { label: 'B', code: 'KeyB' }, { label: 'N', code: 'KeyN' },
    { label: 'M', code: 'KeyM' }, { label: ',', code: 'Comma' }, { label: '.', code: 'Period' },
    { label: '/', code: 'Slash' }, { label: '⇧ Shift', code: 'ShiftRight', w: 2.3 },
    { spacer: true, w: 0.4 }, { label: '↑', code: 'ArrowUp' },
  ],
  [
    { label: 'fn', code: 'Fn', w: 1 }, { label: '⌃ Ctrl', code: 'ControlLeft', w: 1.3 },
    { label: '⌥ Opt', code: 'AltLeft', w: 1.3 }, { label: '⌘ Cmd', code: 'MetaLeft', w: 1.5 },
    { label: 'Space', code: 'Space', w: 4.5 },
    { label: '⌘ Cmd', code: 'MetaRight', w: 1.5 }, { label: '⌥ Opt', code: 'AltRight', w: 1.3 },
    { spacer: true, w: 0.4 },
    { label: '←', code: 'ArrowLeft' }, { label: '↓', code: 'ArrowDown' }, { label: '→', code: 'ArrowRight' },
  ],
];

const KEY_W = 40; // base key width unit in px (smaller than before for better fit)

export default function KeyboardTester() {
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const [testedKeys, setTestedKeys] = useState(new Set());
  const [os, setOs] = useState('windows');

  const layout = os === 'mac' ? MAC_LAYOUT : WINDOWS_LAYOUT;
  const totalKeys = os === 'mac' ? 78 : 104;

  const handleKeyDown = useCallback((e) => {
    e.preventDefault();
    setPressedKeys(prev => new Set([...prev, e.code]));
    setTestedKeys(prev => new Set([...prev, e.code]));
  }, []);

  const handleKeyUp = useCallback((e) => {
    e.preventDefault();
    setPressedKeys(prev => { const n = new Set(prev); n.delete(e.code); return n; });
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [handleKeyDown, handleKeyUp]);

  const resetTest = () => { setPressedKeys(new Set()); setTestedKeys(new Set()); };
  const progress = Math.min(100, Math.round((testedKeys.size / totalKeys) * 100));

  return (
    <div className="tester-wrap">
      <div className="tester-header">
        <div className="tester-stats">
          <div className="stat">
            <span className="stat-val">{testedKeys.size}</span>
            <span className="stat-label">Tested</span>
          </div>
          <div className="stat">
            <span className="stat-val">{Math.max(0, totalKeys - testedKeys.size)}</span>
            <span className="stat-label">Left</span>
          </div>
          <div className="stat">
            <span className="stat-val accent">{progress}%</span>
            <span className="stat-label">Done</span>
          </div>
        </div>
        <button className="reset-btn" onClick={resetTest}>↺ Reset</button>
      </div>

      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>

      <div className="os-tabs">
        <button className={`os-btn ${os === 'windows' ? 'active' : ''}`} onClick={() => { setOs('windows'); resetTest(); }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/></svg>
          Windows
        </button>
        <button className={`os-btn ${os === 'mac' ? 'active' : ''}`} onClick={() => { setOs('mac'); resetTest(); }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/></svg>
          macOS
        </button>
      </div>

      <div className="touch-notice">
        📱 Touch device detected — connect a physical keyboard to test keys. Tap keys in the virtual layout below to see their codes.
      </div>

      <div className="keyboard-scroll-hint">
        <span>← Swipe to scroll keyboard →</span>
      </div>

      <div className="keyboard-scroll-wrap">
        <div className="keyboard-container">
          {layout.map((row, ri) => (
            <div className="kb-row" key={ri}>
              {row.map((key, ki) => {
                if (key.spacer) return (
                  <div key={ki} className="key-spacer"
                    style={{ width: `${(key.w || 1) * KEY_W}px` }} />
                );
                const isPressed = pressedKeys.has(key.code);
                const isTested = testedKeys.has(key.code);
                return (
                  <div key={ki}
                    className={`key ${isPressed ? 'pressed' : ''} ${isTested && !isPressed ? 'tested' : ''} ${key.h === 2 ? 'tall' : ''} ${os === 'mac' ? 'mac-key' : ''}`}
                    style={{
                      width: `${(key.w || 1) * KEY_W - 3}px`,
                      minWidth: `${(key.w || 1) * KEY_W - 3}px`
                    }}
                  >
                    <span className="key-label">{key.label}</span>
                    {isPressed && <span className="key-glow" />}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <div className="tester-legend">
        <div className="legend-item"><span className="legend-dot pressed-dot" />Pressed</div>
        <div className="legend-item"><span className="legend-dot tested-dot" />Tested</div>
        <div className="legend-item"><span className="legend-dot idle-dot" />Untested</div>
      </div>
    </div>
  );
}
